const TABLE_HEADER_HEIGHT_PX = 40
const TABLE_PAGINATION_HEIGHT_PX = 56
const DEFAULT_TABLE_ROW_HEIGHT_PX = 56
const TABLE_STATE_MESSAGE_MIN_HEIGHT_PX = 180

interface GetSettingsTableHeightIProps {
  isLoading: boolean
  pageSize: number
  rowCount: number
  rowHeight?: number
}

export const getSettingsTableHeight = ({
  isLoading,
  pageSize,
  rowCount,
  rowHeight = DEFAULT_TABLE_ROW_HEIGHT_PX,
}: GetSettingsTableHeightIProps): string => {
  const bodyHeight = isLoading
    ? pageSize * rowHeight
    : rowCount > 0
    ? rowCount * rowHeight
    : TABLE_STATE_MESSAGE_MIN_HEIGHT_PX

  return `${TABLE_HEADER_HEIGHT_PX + TABLE_PAGINATION_HEIGHT_PX + bodyHeight}px`
}
